const React = require("react");
/*const auth = require("../../Authenticator.js");*/
const server = require("../../Server.js");


function getPAFile(url) {
    return function() {
        server.Get(url).then((res) => {
            res.blob().then((blob) => {
                var url = window.URL.createObjectURL(blob);
                var a = window.document.createElement('a');
                a.href = url;
                a.download = "PAFile.csv";
                a.click();  
            });
        });
    };
}

const PropertyAccountantAssignmentsForm = React.createClass({
    render() {
        return (<div>
            Property Accountant store assignments file:&nbsp;
            <a href="javascript:void(0)" target="_blank" onClick={getPAFile(this.props.SampleFileURL)}>Click here to download</a>
        </div>);
    }
});

module.exports = PropertyAccountantAssignmentsForm;


// WEBPACK FOOTER //
// ./src/components/metadata/PropertyAccountantAssignmentsForm.jsx